import { render, staticRenderFns } from "./CheckPinCode.vue?vue&type=template&id=315beccc&scoped=true&"
import script from "./CheckPinCode.vue?vue&type=script&lang=js&"
export * from "./CheckPinCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315beccc",
  null
  
)

export default component.exports